<div id="contact_link" class="target-element"></div>
<div class="contact_container">
    <img src="./../../../assets/ellipse.png" class="ellipsis_1">
    <img src="./../../../assets/ellipse.png" class="ellipsis_2">
    <img src="./../../../assets/ellipse.png" class="ellipsis_3">

    <div class="content">
        <h1 id="contact">Kontakt</h1>
        <div class="left_and_right_side">
            <div class="left_side">
                <h2 id="gotAProblem">Sie sind Interessiert?</h2>
                <p id="contactMeText">Dann kontaktieren Sie mich. <br> 
                    Ich bin motiviert bei der Umsetzung Ihrer Projekte mitzuwirken.</p>

                <span id="needADeveloper">Wir können alle Anregungen und offenen Fragen klären. <br> <b>Ich freue mich auf Sie!</b></span>
            </div>


            <form class="right_side" (ngSubmit)="onSubmit(contactForm)" #contactForm="ngForm" 
            (input)="resetMailSuccessfullySent();enableSubmitButton();" (change)="enableSubmitButton();">
                <input type="text" placeholder="Name" required id="clientName" [(ngModel)]="contactData.name" name="name" #name="ngModel">
                @if (!name.valid && name.touched) {
                    <span style="color:red;">Name required</span>
                }
                <input type="text" placeholder="E-Mail" required id="clientEmail" [(ngModel)]="contactData.email" pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}" name="email" #mail="ngModel">
                @if (!mail.valid && mail.touched) {
                    <span style="color:red;">E-mail address required</span>
                }
                <textarea placeholder="Nachricht" required id="clientMessage" [(ngModel)]="contactData.message" name="message" #message="ngModel"></textarea>
                @if (!message.valid && message.touched) {
                    <span style="color:red;">Message required</span>
                }
                <div>
                    <input type="checkbox" id="checkbox" (change)="check()" #checkbox>
                    <span id="read_privacy_policy"> 
                        <span id="read_privacy_policyDE" *ngIf="this.languagesTS.loadGerman"> 
                            Ich habe die <a routerLink="/privacyPolicy">Datenschutzerklärung</a> gelesen und bin mit der beschriebenen Verarbeitung meiner Daten einverstanden.
                        </span>
                        <span id="read_privacy_policyEN" *ngIf="this.languagesTS.loadEnglish"> 
                            I've read the <a routerLink="/privacyPolicy">privacy policy</a> and agree to the processing of my data as outlined.
                        </span>
                    </span>
                </div>
                <span style="display:none;" id="mailSuccess">Die Nachricht wurde erfolgreich abgesendet</span>
                <div class="buttonContainerCenter">
                    <div>
                        <button class="buttonGrey" id="sayHello" type="submit" >Say hello ;)</button>
                    </div>
                </div>
            </form>

        </div>

        <div class="go_up_container">
            <a (click)="this.goTop()"><img src="./../../../assets/contact/go_up.png" class="go_up_icon"></a>
            <a (click)="this.goTop()"><img src="./../../../assets/contact/go_up_hover.png" class="go_up_icon_hover"></a>
        </div>

    </div>


</div>